export const REFRESH_TOKEN_ROUTE_PARAMS = 'refreshToken';
export const REDIRECT_TO_QUERY_PARAMS = 'redirectTo';
export const PWA_FROM_QR_QUERY_PARAM = 'from';
export const PWA_FROM_QR_VALUE = 'qr';

export const index = `${process.env.REACT_APP_PREFIX}c/:${REFRESH_TOKEN_ROUTE_PARAMS}`;
export const help_no_token_word = 'no-token';
export const index_no_token = `${process.env.REACT_APP_PREFIX}c/${help_no_token_word}`;
export const login = `${process.env.REACT_APP_PREFIX}login`;
export const unauthorized = `${process.env.REACT_APP_PREFIX}unauthorized`;
export const root = `${process.env.REACT_APP_PREFIX}`;
export const dashboard = `${process.env.REACT_APP_PREFIX}p/dashboard`;
export const redirect_to_dashboard = 'dashboard';
export const ancs = `${process.env.REACT_APP_PREFIX}p/ancs`;
export const ancsEvery2Hours = `${process.env.REACT_APP_PREFIX}p/ancs_every_2_hours`;
export const ancsV2 = `${process.env.REACT_APP_PREFIX}p/ancs_v2`;
export const redirect_to_ancs = 'ancs';
export const redirect_to_ancs_every_2_hours = 'ancs_every_2_hours';
export const redirect_to_ancs_v2 = 'ancs_v2';
export const thresholds = `${process.env.REACT_APP_PREFIX}p/thresholds`;
export const redirect_to_thresholds = 'thresholds';
export const types = `${process.env.REACT_APP_PREFIX}p/types`;
export const redirect_to_types = 'types';
export const product_types = `${process.env.REACT_APP_PREFIX}p/product_types`;
export const redirect_to_product_types = 'product_types';
export const map_avatars_v2 = `${process.env.REACT_APP_PREFIX}p/map_avatars_v2`;
export const redirect_to_map_avatars_v2 = 'map_avatars_v2';
export const prestataires = `${process.env.REACT_APP_PREFIX}p/prestataires`;
export const redirect_to_prestataires = 'prestataires';
